module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/writable-browser.js
// module id = ./node_modules/readable-stream/writable-browser.js
// module chunks = vendor